/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect } from 'react';
import AmplifyModal from '@amplify/amplify-modal';
import PropTypes from 'prop-types';
import { clearAllBodyScrollLocks } from 'body-scroll-lock';

const SecondAttemptBulkInvalidationModal = ({
    isSecondAttemptBulkInvalidationModalShown,
    invalidateD8SecondAttemptResults,
    hideSecondAttemptBulkInvalidationModal,
    studentInfo,
}) => {
    useEffect(() => {
        return () => {
            document.body.classList.remove('modal-open');
            document.body.style.overflow = null;
        };
    }, []);
    return (
        <div className="invalidate-modal-container">
            <AmplifyModal
                fitContent
                aria-labelledby="second-attemt-bulk-invalidation-modal"
                onClose={() => {
                    clearAllBodyScrollLocks();
                    hideSecondAttemptBulkInvalidationModal();
                }}
                open={isSecondAttemptBulkInvalidationModalShown}
                title="Reset Composite Score"
                primaryButtonText="Continue"
                secondaryButtonText="Cancel"
                onPrimaryAction={() => {
                    clearAllBodyScrollLocks();
                    hideSecondAttemptBulkInvalidationModal();
                    invalidateD8SecondAttemptResults(studentInfo.id);
                }}
                onSecondaryAction={() => {
                    clearAllBodyScrollLocks();
                    hideSecondAttemptBulkInvalidationModal();
                }}
            >
                <p>
                    {`By clicking Continue, ${studentInfo.firstName}’s 2nd attempt composite score for DIBELS 8 will be reset. They will now be able to be assessed for a 3rd attempt. Click Continue to reset ${studentInfo.firstName}’s 2nd attempt composite score.`}{' '}
                </p>

                <p>
                    IMPORTANT:
                    {` When you click Continue, ${studentInfo.firstName}’s 2nd attempt measure scores will no longer be visible on the mCLASS Classroom Reporting page. `}
                    <a
                        target="_blank"
                        href="https://doe.louisiana.gov/docs/default-source/assessment/testing-irregularity.pdf?sfvrsn=f3ec8c1f_1"
                        rel="noreferrer"
                    >
                        Please see detailed information here.
                    </a>
                </p>

                <p>Do you wish to continue?</p>
            </AmplifyModal>
        </div>
    );
};

SecondAttemptBulkInvalidationModal.defaultProps = {
    isSecondAttemptBulkInvalidationModalShown: false,
    hideSecondAttemptBulkInvalidationModal: () => {},
    invalidateD8SecondAttemptResults: () => {},
    studentInfo: {},
};

SecondAttemptBulkInvalidationModal.propTypes = {
    isSecondAttemptBulkInvalidationModalShown: PropTypes.bool,
    hideSecondAttemptBulkInvalidationModal: PropTypes.func,
    invalidateD8SecondAttemptResults: PropTypes.func,
    studentInfo: PropTypes.object,
};

export default SecondAttemptBulkInvalidationModal;
